import { CropYear, IOmniaShell, IPcnAnalysis, isDate, numericTextSort, OmniaObjectType } from "../../omnia"
import { ISoilService } from "../../types"
import { getActivity } from "../activity"
import { AnalysisEditCtrl } from "../edit"

/// <reference path="../edit.ts" />

export class PcnAnalysisEditCtrl extends AnalysisEditCtrl<IPcnAnalysis> {

    static createPopup(): ng.IDirective {
        return super.create(PcnAnalysisEditCtrl);
    };

    private _pcnAnalysis: IPcnAnalysis;

    public userDefinedYear: boolean;

    static $inject = ["$scope", "OmniaSoilService", "OmniaShell"];

    constructor($scope: ng.IScope, svc: ISoilService, shell: IOmniaShell) {

        super($scope, svc, shell);

        super.setup();

        this.hideLaboratory = true;
    }

    protected getTypeInfo() {
        return { name: "PCN analysis", title: "PCN analysis", type: OmniaObjectType.PcnAnalysis }
    }

    protected getPopupTemplate(): string {
        return "app/soil/edit/pcn/pcn.html";
    }

    protected setupAnalysis(a: IPcnAnalysis) {

        this._pcnAnalysis = a;

        this.allocTargets = this.svc.fields
        this.allocTargets = numericTextSort(this.allocTargets, t => t.description)

        this.selectedAllocTargets = !!this._pcnAnalysis && this._pcnAnalysis.Allocations && this._pcnAnalysis.Allocations.length
            ? this.allocTargets.filter(f => this._pcnAnalysis.Allocations.filter(a => a.FieldId === f.fieldId)
                .length > 0)
            : this.cmd && this.cmd.alloc ? [this.allocTargets.find(f => f.fieldId === this.cmd.alloc.fieldId)] : [];

        this.deletedAllocTargets = [];

        this.userDefinedYear = !this.newAnalysis;

    }

    protected getActivity() {
        const a = this._pcnAnalysis
        return getActivity(this.newAnalysis, { type: OmniaObjectType.PcnAnalysis, id: a?.PcnAnalysisId, number: a?.AnalysisNumber })
    }

    protected saveAnalysis(): ng.IPromise<number> {

        this._pcnAnalysis.IsValid = true;

        let allocFieldsIds = this.selectedAllocTargets && this.selectedAllocTargets.length > 0 ? this.selectedAllocTargets.map(f => f.fieldId) : null;

        // Rounding
        if (this._pcnAnalysis.EggsPerGram) {
            this._pcnAnalysis.EggsPerGram = Math.round(this._pcnAnalysis.EggsPerGram * 10) / 10;
        }

        if (this._pcnAnalysis.CystsPer100Gram) {
            this._pcnAnalysis.CystsPer100Gram = Math.round(this._pcnAnalysis.CystsPer100Gram * 10) / 10;
        }

        return this.svc.savePcnAnalysis(this._pcnAnalysis, this.newAnalysis && this.allocTarget ? [this.allocTarget.fieldId] : allocFieldsIds);

    }

    protected updateOnDateChanged() {

        let currentYear = this._pcnAnalysis.FirstYear;
        if (this.userDefinedYear && currentYear) return;

        let date = this.analysis.SamplingDate;

        if (isDate(date)) {
            this._pcnAnalysis.FirstYear = CropYear.getYearFromDate(date);
        }

    }

    protected deleteAnalysis(deleteOtherGridSamples: boolean) {

        let id = this._pcnAnalysis.PcnAnalysisId;
        if (!id) return null;

        return this.svc.deletePcnAnalysis(id, deleteOtherGridSamples);
    }

}
